import { getToken } from 'data/auth/utils'
import { EntityId } from 'entities-next/common'
import { pick } from 'lodash'
import { createApiHandler, CreateApiHandlerConfig } from 'services-next/api'
import { getUrlWithPathParams } from 'utils-next/api'

import { CreateScoutingCampaignCriteriaDto, ScoutingCampaignCriteriaDto } from './scoutingCampaignCriteria.types'

const SCOUTING_CAMPAIGN_CRITERIA_ENDPOINT_PATH = 'admin/scouting-campaign/'

export function getApiScoutingCampaignCriteriaHandlers(
  customToken?: string,
  config: Omit<CreateApiHandlerConfig, 'baseUrl'> = {}
) {
  const token = customToken || getToken() || undefined
  const { callApi } = createApiHandler(token, config)

  async function apiGetScoutingCampaignCriteria(scoutingCampaignId: EntityId): Promise<ScoutingCampaignCriteriaDto> {
    const scoutingCampaignCriteria = await callApi<ScoutingCampaignCriteriaDto>({
      url: getUrlWithPathParams(SCOUTING_CAMPAIGN_CRITERIA_ENDPOINT_PATH, `${scoutingCampaignId}/criteria`),
    })
    return scoutingCampaignCriteria
  }

  async function apiSaveScoutingCampaignCriteria(
    scoutingCampaignId: EntityId,
    scoutingCampaignCriteria: CreateScoutingCampaignCriteriaDto
  ): Promise<ScoutingCampaignCriteriaDto> {
    const savedScoutingCampaignCriteria = await callApi<ScoutingCampaignCriteriaDto>({
      method: 'put',
      url: getUrlWithPathParams(SCOUTING_CAMPAIGN_CRITERIA_ENDPOINT_PATH, `${scoutingCampaignId}/criteria`),
      data: {
        negativeOrganizationHeadquarters: scoutingCampaignCriteria.negativeOrganizationHeadquarters
          ? pick(scoutingCampaignCriteria.negativeOrganizationHeadquarters, 'locations')
          : undefined,
        organizationHeadquarters: scoutingCampaignCriteria.organizationHeadquarters
          ? pick(scoutingCampaignCriteria.organizationHeadquarters, 'locations')
          : undefined,
        organizationFoundedAt: scoutingCampaignCriteria.organizationFoundedAt
          ? pick(scoutingCampaignCriteria.organizationFoundedAt, ['minimumYear', 'maximumYear'])
          : undefined,
        organizationStages: scoutingCampaignCriteria.organizationStages
          ? pick(scoutingCampaignCriteria.organizationStages, 'stages')
          : undefined,
      },
    })

    return savedScoutingCampaignCriteria
  }

  return {
    apiGetScoutingCampaignCriteria,
    apiSaveScoutingCampaignCriteria,
  }
}
